import { Injectable } from '@angular/core';
import { Title } from '@models/title';
import { TitlesService } from 'app/core/titles/titles.service';
import { Observable } from 'rxjs';

@Injectable()
export class TitlesResolver {
    public constructor(private titlesService: TitlesService) {}

    public resolve(): Observable<Title[]> {
        return this.titlesService.titles$;
    }
}
